export default __webpack_public_path__ + "static/media/image1.953935cd.jpg";